import classNames from 'classnames';

import { Typography } from '@sravni/react-design-system';

import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

import styles from './FullDealEntryPointDisclaimer.module.scss';

export function FullDealEntryPointDisclaimer({ className, link }: { className: string; link: string }) {
  return (
    <Typography.Text className={classNames(styles.disclaimer, className)}>
      Заем бесплатно при возврате в срок.{UNBREAKABLE_SEPARATOR}
      <a target="_blank" rel="noreferrer" href={link}>
        Подробнее
      </a>
    </Typography.Text>
  );
}
